module.exports = __webpack_public_path__ + "img/122.34eeb3da.png";